<div class="stake-page" [class.stake-page--mobile]="isMobileView">
  <div class="stake-shell" *ngIf="webinar !== undefined">

    <section class="stake-hero">
      <div class="stake-gallery" *ngIf="webinar?.webinarImages.length > 0">
        <span class="stake-ribbon stake-ribbon--free" *ngIf="webinar?.isFreeBee">Freebie</span>
        <span class="stake-price-pill" [class.stake-price-pill--free]="isFree">{{ displayPrice }}</span>
        <app-webinar-images [images]="webinarImagesUrls"></app-webinar-images>
      </div>

      <div class="stake-info">
        <p class="stake-kicker">
          <i class="fa fa-door-open" aria-hidden="true"></i>
          {{ webinar?.room?.roomName }}
        </p>
        <h1 class="stake-title">{{ webinar?.name }}</h1>
        <p class="stake-sub">Claim a seat to watch the recorded product review. When the last seat sells, the video plays and a random seat is chosen as the winner.</p>

        <div class="stake-chips">
          <div class="stake-chip stake-chip--total">
            <span class="stake-chip__icon" aria-hidden="true"><i class="fa fa-users"></i></span>
            <span class="stake-chip__copy">
              <small>Total seats</small>
              <strong>{{ webinar?.numberOfSeats }}</strong>
            </span>
          </div>
          <div class="stake-chip stake-chip--price" [class.stake-chip--free]="isFree">
            <span class="stake-chip__icon" aria-hidden="true"><i class="fa fa-coins"></i></span>
            <span class="stake-chip__copy">
              <small>Price each</small>
              <strong>
                <span class="gold-dollar" *ngIf="!isFree">$</span>{{ displayPriceAmount }}
              </strong>
            </span>
          </div>
          <div
            class="stake-chip stake-chip--left"
            [class.stake-chip--hot]="isLowSeats && !isSoldOut"
            [class.stake-chip--sold]="isSoldOut">
            <span class="stake-chip__icon" aria-hidden="true">
              <i class="fa" [ngClass]="isSoldOut ? 'fa-lock' : 'fa-ticket-alt'"></i>
            </span>
            <span class="stake-chip__copy">
              <small>{{ isSoldOut ? 'Sold out' : 'Seats left' }}</small>
              <strong>{{ seatsLeft }}</strong>
            </span>
          </div>
        </div>

        <div class="stake-meter" [attr.aria-label]="seatsLeft + ' of ' + webinar?.numberOfSeats + ' seats left'">
          <div class="stake-meter__top">
            <span>{{ seatsTaken }} claimed</span>
            <span>{{ fillPercent }}% filled</span>
          </div>
          <div class="stake-meter__track">
            <div
              class="stake-meter__fill"
              [class.stake-meter__fill--hot]="isLowSeats && !isSoldOut"
              [class.stake-meter__fill--sold]="isSoldOut"
              [style.width.%]="fillPercent"></div>
          </div>
          <p class="stake-meter__note" *ngIf="hasPerAccountCap">
            Limit {{ accountSeatLimit }} {{ accountSeatLimit === 1 ? 'seat' : 'seats' }} per account
          </p>
        </div>
      </div>
    </section>

    <section class="stake-floor-card">
      <div class="stake-floor-head">
        <p class="stake-kicker">Seating</p>
        <h2 class="stake-section-title">Choose your seats</h2>
        <p class="stake-sub stake-sub--tight">Available chairs light up on hover. Booked seats stay dim. Tap to hold a spot for the recorded reveal.</p>
      </div>
      <app-purchase-seats></app-purchase-seats>
    </section>

    <section class="stake-tabs-card">
      <mat-tab-group class="stake-tabs" animationDuration="280ms">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="stake-tab-label">
              <i class="fa fa-scroll" aria-hidden="true"></i>
              Description
            </span>
          </ng-template>
          <div class="stake-desc">
            <div class="stake-meta">
              <div class="stake-meta__item">
                <i class="fa fa-calendar-alt" aria-hidden="true"></i>
                <span>
                  <small>Start date</small>
                  <strong *ngIf="webinar.statusId > 1">{{ webinar?.startDateTime | date: 'dd MMM yyyy' }}</strong>
                  <strong *ngIf="webinar.statusId === 1">TBD</strong>
                </span>
              </div>
              <div
                class="stake-meta__item"
                *ngIf="webinar?.closeDateTime !== null && webinar?.closeDateTime !== undefined && webinar.closeDateTime">
                <i class="fa fa-calendar-check" aria-hidden="true"></i>
                <span>
                  <small>Closes</small>
                  <strong *ngIf="webinar.statusId > 1">{{ webinar?.closeDateTime | date: 'dd MMM yyyy h:mm a' }}</strong>
                  <strong *ngIf="webinar.statusId === 1">TBD</strong>
                </span>
              </div>
              <div class="stake-meta__item">
                <i class="fa fa-video" aria-hidden="true"></i>
                <span>
                  <small>Video length</small>
                  <strong>{{ videoLengthLabel(webinar?.videoLengthInSec) }}</strong>
                </span>
              </div>
            </div>

            <p class="stake-desc__kicker">
              <i class="fa fa-gift" aria-hidden="true"></i>
              Product review webinar + random winner giveaway
            </p>
            <p class="stake-desc__lead">Take a look at this webinar.</p>
            <p>
              Join us for a recorded, up-close review of <strong>{{ webinar?.name }}</strong>.
              We'll walk through the product in detail and share a 100% unbiased opinion based on real review experience.
            </p>

            <div class="stake-callout">
              <p class="stake-callout__title">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Seats are limited
              </p>
              <ul>
                <li>
                  <i class="fa fa-users" aria-hidden="true"></i>
                  Limited to <strong>ONLY {{ webinar?.numberOfSeats }}</strong> viewers
                </li>
                <li *ngIf="webinar?.maxSeatsAllowedPerUser != null && webinar?.numberOfSeats !== webinar?.maxSeatsAllowedPerUser">
                  <i class="fa fa-user-lock" aria-hidden="true"></i>
                  Limit per account: <strong>{{ webinar?.maxSeatsAllowedPerUser }}</strong> seat(s)
                </li>
                <li>
                  <i class="fa fa-clock" aria-hidden="true"></i>
                  First-come, first-served. Once sold out, registration closes and the recorded webinar starts <strong>10 minutes</strong> after the last seat is purchased. A random seat is then selected as the winner.
                </li>
              </ul>
            </div>

            <div class="stake-rules">
              <p class="stake-rules__title">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                What you're purchasing
              </p>
              <ul>
                <li class="is-yes">
                  <i class="fa fa-check-circle" aria-hidden="true"></i>
                  A <strong>seat to VIEW</strong> a product review webinar
                </li>
                <li class="is-no">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                  <strong>Not</strong> a purchase of the product being reviewed
                </li>
              </ul>
              <p class="stake-rules__note">
                <i class="fa fa-ticket-alt" aria-hidden="true"></i>
                Your seat grants access to the webinar stream. You are paying for access to the webinar.
              </p>
            </div>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <span class="stake-tab-label">
              <i class="fa fa-comments" aria-hidden="true"></i>
              Reviews
              <em>{{ totalReviews }}</em>
            </span>
          </ng-template>

          <div class="stake-reviews">
            <aside class="stake-composer">
              <h3>Leave a review</h3>
              <p>Share what stood out. At least 20 characters.</p>
              <mat-form-field appearance="outline" class="stake-field">
                <textarea
                  matInput
                  placeholder="Leave a comment"
                  rows="6"
                  [(ngModel)]="reviewInput"></textarea>
              </mat-form-field>
              <div class="stake-composer__actions">
                <a
                  class="seat-cta"
                  role="button"
                  tabindex="0"
                  *ngIf="!isUpdatingReview"
                  [class.seat-cta--off]="reviewInput === '' || reviewInput === null || reviewInput === undefined || reviewInput.length < 20"
                  (click)="reviewInput?.length >= 20 && postComment(webinar)"
                  (keyup.enter)="reviewInput?.length >= 20 && postComment(webinar)">
                  Post comment
                </a>
                <a
                  class="seat-cta"
                  role="button"
                  tabindex="0"
                  *ngIf="reviewForEdit !== undefined && isUpdatingReview"
                  [class.seat-cta--off]="reviewInput.length < 20"
                  (click)="reviewInput?.length >= 20 && onUpdateCommentPost()"
                  (keyup.enter)="reviewInput?.length >= 20 && onUpdateCommentPost()">
                  Update comment
                </a>
                <a
                  class="seat-cta seat-cta--ghost"
                  role="button"
                  tabindex="0"
                  *ngIf="isUpdatingReview"
                  (click)="onUpdateCancel()"
                  (keyup.enter)="onUpdateCancel()">
                  Cancel
                </a>
              </div>
            </aside>

            <div class="stake-review-list">
              <h3>All reviews</h3>
              <p class="stake-empty" *ngIf="!reviewList?.length">No comments yet. Be the first at the table.</p>
              <article class="stake-review" *ngFor="let review of reviewList">
                <header class="stake-review__head">
                  <img [src]="avatarImg" class="stake-avatar" alt="" />
                  <div>
                    <strong>{{ review.reviewerName }}</strong>
                    <time>{{ review?.reviewDate | date: 'dd MMM yyyy' }}</time>
                  </div>
                </header>
                <p class="stake-review__body">{{ review.reviewComment }}</p>
                <div class="stake-review__actions">
                  <button
                    type="button"
                    class="vote-btn vote-btn--up"
                    [class.is-on]="isAlreadyVotedPositive(review)"
                    [class.is-disabled]="isAlreadyVotedNegative(review)"
                    (click)="isAlreadyVotedPositive(review) ? onRemoveWebinarHelpScore(review) : onAddWebinarHelpScore(review, true)"
                    [matTooltip]="isAlreadyVotedPositive(review) ? 'Already responded, remove response' : 'Was helpful'">
                    <i class="fa" [ngClass]="isAlreadyVotedPositive(review) ? 'fa-thumbs-up' : 'fa-thumbs-o-up'"></i>
                    <span>{{ getPositiveHelpScore(review) }}</span>
                  </button>
                  <button
                    type="button"
                    class="vote-btn vote-btn--down"
                    [class.is-on]="isAlreadyVotedNegative(review)"
                    [class.is-disabled]="isAlreadyVotedPositive(review)"
                    (click)="isAlreadyVotedNegative(review) ? onRemoveWebinarHelpScore(review) : onAddWebinarHelpScore(review, false)"
                    [matTooltip]="isAlreadyVotedNegative(review) ? 'Already responded, remove response' : 'Was not helpful'">
                    <i class="fa" [ngClass]="isAlreadyVotedNegative(review) ? 'fa-thumbs-down' : 'fa-thumbs-o-down'"></i>
                    <span>{{ getNegativeHelpScore(review) }}</span>
                  </button>
                  <button
                    type="button"
                    class="vote-btn"
                    *ngIf="isReviewOwner(review)"
                    (click)="updateReview(review)"
                    matTooltip="Edit review">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    type="button"
                    class="vote-btn vote-btn--danger"
                    *ngIf="isDeleteAllowed(review)"
                    (click)="deleteReview(review)"
                    matTooltip="Delete review">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </div>
              </article>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </section>
  </div>
</div>
